import { useLanguage } from "@/i18n/LanguageContext";

const guarantees = [
  { timeKey: "serviceAreas.respTime1", labelKey: "serviceAreas.respLabel1", noteKey: "serviceAreas.respNote1" },
  { timeKey: "serviceAreas.respTime2", labelKey: "serviceAreas.respLabel2", noteKey: "serviceAreas.respNote2" },
  { timeKey: "serviceAreas.respTime3", labelKey: "serviceAreas.respLabel3", noteKey: "serviceAreas.respNote3" },
  { timeKey: "serviceAreas.respTime4", labelKey: "serviceAreas.respLabel4", noteKey: "serviceAreas.respNote4" },
];

export default function ResponseTimeSection() {
  const { t } = useLanguage();
  return (
    <section className="bg-secondary py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-white mb-3">
            {t("serviceAreas.responseH2")}
          </h2>
          <p className="text-base text-[#fefce8] max-w-[720px] mx-auto leading-relaxed">
            {t("serviceAreas.responseSub")}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {guarantees.map((g) => (
            <div
              key={g.labelKey}
              className="bg-secondary border-l-4 border-primary p-6 rounded-r-lg"
            >
              <div className="text-3xl md:text-4xl font-black text-[#fbbf24] mb-2">
                {t(g.timeKey)}
              </div>
              <div className="text-base font-bold text-white mb-1">
                {t(g.labelKey)}
              </div>
              <div className="text-sm text-[#fefce8]">
                {t(g.noteKey)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}